var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { bool, node, string } from 'prop-types';
import LinkLayout from './LinkLayout';
import styles from './styles.scss';
import DataPickerArrow from '../../../Icons/dist/components/DataPickerArrow';

var Link = function Link(_ref) {
  var children = _ref.children,
      isDiminishedHover = _ref.isDiminishedHover,
      isActive = _ref.isActive,
      withArrow = _ref.withArrow,
      badge = _ref.badge,
      dataHook = _ref.dataHook,
      rest = _objectWithoutProperties(_ref, ['children', 'isDiminishedHover', 'isActive', 'withArrow', 'badge', 'dataHook']);

  return React.createElement(
    LinkLayout,
    { isDiminishedHover: isDiminishedHover, isActive: isActive },
    React.createElement(
      'a',
      _extends({ 'data-hook': dataHook }, rest),
      children,
      badge,
      withArrow && React.createElement(
        'span',
        { className: styles.linkArrow },
        React.createElement(DataPickerArrow, null)
      )
    )
  );
};

Link.defaultProps = {
  dataHook: 'menu-navigation-link',
  withArrow: false
};

Link.propTypes = {
  children: node,
  isActive: bool,
  withArrow: bool,
  badge: node,
  isDiminishedHover: bool,
  dataHook: string
};

export default Link;
//# sourceMappingURL=Link.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/navigation/Link.js